import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { compose } from 'redux';

import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dropdown } from 'primereact/dropdown';

import Header from '@components/Header';

import { validatePermissionAction } from '@actions/sessionPermission';
import {
  getReportTotalSupplierByCountry,
  reportTotalSupplierByCountry,
  reportDetailSupplier,
  getReportTotalFoliosPC,
  getReportUnassociatedMSDetail,
  reportUnassociatedMSDetail,
  reportDetailPC,
} from '@actions/users';

import catalogPermissionsId from '@constants/catalogPermissionsId';

class ReportUsersSuppliers extends Component {
  constructor(props) {
    super(props);
    const { t } = props;
    this.reportTypeOptions = [
      { label: t('Proveedores por país'), id: 'suppliersByCountry' },
      { label: t('Consolidado'), id: 'consolidated' },
      { label: t('Terceros sin asociación'), id: 'unassociatedMS' },
    ];
    this.state = {
      loadingTable: true,
      loadingBtn1: false,
      loadingBtn2: false,
      reportType: this.reportTypeOptions[0],
      fullData: [],
      data: [],
      lazyParams: {
        first: 0,
        rows: 7,
        page: 0,
      },
    };
  }

  async componentDidMount() {
    await this.loadData();
  }

  loadData = async () => {
    const {
      getReportTotalSupplierByCountry,
      getReportTotalFoliosPC,
      getReportUnassociatedMSDetail,
    } = this.props;
    const { reportType } = this.state;
    this.setState({ loadingTable: true });
    let response;

    if (reportType.id === 'consolidated') {
      const consolidatedResponse = await getReportTotalFoliosPC();
      response = consolidatedResponse?.status
        ? consolidatedResponse
        : {
          ...consolidatedResponse,
          data: this.sortConsolidated(consolidatedResponse?.data),
        };
    } else if (reportType.id === 'unassociatedMS') {
      response = await getReportUnassociatedMSDetail();
    } else {
      response = await getReportTotalSupplierByCountry();
    }

    if (!response?.status) {
      return this.setState({
        fullData: response.data,
        data: response.data,
        loadingTable: false,
      });
    }
    return this.setState({ loadingTable: false });
  };

  onTotalSupplierByCountry = async () => {
    const { reportTotalSupplierByCountry } = this.props;
    this.setState({ loadingBtn1: true });
    await reportTotalSupplierByCountry();
    this.setState({ loadingBtn1: false });
  };

  onDetailSupplier = async () => {
    const { reportDetailSupplier } = this.props;
    this.setState({ loadingBtn2: true });
    await reportDetailSupplier();
    this.setState({ loadingBtn2: false });
  };

  onDetailConsolidated = async () => {
    const { reportDetailPC } = this.props;
    this.setState({ loadingBtn1: true });
    await reportDetailPC();
    this.setState({ loadingBtn1: false });
  };

  onDetailUnassociatedMS = async () => {
    const { reportUnassociatedMSDetail } = this.props;
    this.setState({ loadingBtn1: true });
    await reportUnassociatedMSDetail();
    this.setState({ loadingBtn1: false });
  };

  onChangeReportType = ({ target }) => {
    this.setState({
      reportType: target.value,
      fullData: [],
      data: [],
      lazyParams: {
        first: 0,
        rows: 7,
        page: 0,
      },
    }, this.loadData);
  };

  sortConsolidated = (data) => {
    if (!Array.isArray(data)) return [];

    return [...data].sort((a, b) => {
      const companyComparison = (a?.nombreEmpresa || '').localeCompare(
        b?.nombreEmpresa || '',
        'es',
        { sensitivity: 'base' }
      );

      if (companyComparison !== 0) return companyComparison;

      return (a?.paisSap || '').localeCompare(b?.paisSap || '', 'es', {
        sensitivity: 'base',
      });
    });
  };

  loadDataByPage = () => {
    const { lazyParams, fullData } = this.state;
    const dataPage = fullData.slice(lazyParams.first, lazyParams.first + lazyParams.rows);
    this.setState({ data: dataPage });
  };

  onPage = (event) => {
    const { lazyParams } = this.state;
    const nextLazyParams = { ...lazyParams, ...event };
    this.setState({ lazyParams: nextLazyParams }, this.loadDataByPage);
  };

  columnResponsive = (rowData, detail) => (
    <>
      <span className="p-column-title">{detail.header}</span>
      {rowData[detail.field]}
    </>
  )

  emailColumnResponsive = (rowData, detail) => (
    <>
      <span className="p-column-title">{detail.header}</span>
      <span
        style={{
          display: 'block',
          maxWidth: '100%',
          overflowWrap: 'anywhere',
          wordBreak: 'break-word',
        }}
      >
        {rowData[detail.field]}
      </span>
    </>
  )

  renderReportTable = () => {
    const { t } = this.props;
    const {
      fullData,
      data,
      loadingTable,
      lazyParams,
      reportType,
    } = this.state;
    if (reportType.id === 'consolidated') {
      return (
        <DataTable
          value={data}
          lazy
          loading={loadingTable}
          onPage={this.onPage}
          paginator={!!fullData.length}
          rows={lazyParams.rows}
          totalRecords={fullData.length}
          first={lazyParams.first}
          showGridlines
          stripedRows
        >
          <Column header={t('Tipo Tercero')} field="tipoTercero" body={this.columnResponsive} />
          <Column header={t('SAP País')} field="paisSap" body={this.columnResponsive} />
          <Column header={t('SAP ID')} field="idSap" body={this.columnResponsive} />
          <Column header={t('Nombre Empresa')} field="nombreEmpresa" body={this.columnResponsive} />
          <Column header={t('Documento')} field="nif" body={this.columnResponsive} />
        </DataTable>
      );
    }

    if (reportType.id === 'unassociatedMS') {
      return (
        <DataTable
          value={data}
          lazy
          loading={loadingTable}
          onPage={this.onPage}
          paginator={!!fullData.length}
          rows={lazyParams.rows}
          totalRecords={fullData.length}
          first={lazyParams.first}
          showGridlines
          stripedRows
        >
          <Column header={t('NIF')} field="nif" body={this.columnResponsive} />
          <Column header={t('Razón Social')} field="razonSocial" body={this.columnResponsive} />
          <Column
            header={t('Representante Legal')}
            field="nombreRepresentanteLegal"
            body={this.columnResponsive}
          />
          <Column
            header={t('Correo')}
            field="correoRepresentanteLegal"
            body={this.emailColumnResponsive}
          />
        </DataTable>
      );
    }

    return (
      <DataTable
        value={data}
        lazy
        loading={loadingTable}
        onPage={this.onPage}
        paginator={!!fullData.length}
        rows={lazyParams.rows}
        totalRecords={fullData.length}
        first={lazyParams.first}
        showGridlines
        stripedRows
      >
        <Column header={t('País')} field="pais" body={this.columnResponsive} />
        <Column header={t('Total')} field="total" body={this.columnResponsive} />
      </DataTable>
    );
  };

  render() {
    const { t, history, validatePermissionAction } = this.props;
    const {
      loadingBtn1,
      loadingBtn2,
      reportType,
    } = this.state;
    const isConsolidated = reportType.id === 'consolidated';
    const isUnassociatedMS = reportType.id === 'unassociatedMS';
    const isSuppliersByCountry = reportType.id === 'suppliersByCountry';
    let onDetail = this.onDetailSupplier;

    if (isConsolidated) onDetail = this.onDetailConsolidated;
    if (isUnassociatedMS) onDetail = this.onDetailUnassociatedMS;

    const rightHeader = (
      <>
        <Button
          icon="pi pi-th-large"
          className="p-button-raised p-button-text p-button-plain"
          onClick={() => history.push('/dashboard')}
        />
        <Button
          label={t('Regresar')}
          className="p-button-primary"
          onClick={() => history.push('/reports')}
        />
      </>
    );

    return (
      <div className="p-grid p-justify-center">
        <div className="p-col-12">
          <Header title={t('Usuarios Proveedores')} rightComponent={rightHeader} />
          <p>
            {isConsolidated && t('Detalle consolidado de terceros')}
            {isUnassociatedMS && t('Terceros del Micrositio sin asociación')}
            {isSuppliersByCountry && t('Total de proveedores por país')}
          </p>
        </div>

        <div className="p-col-12 p-lg-8 p-mt-2">
          <div className="card">
            <div className="p-pb-1">
              <label>{t('Tipo de reporte')}:</label>
              <Dropdown
                name="reportType"
                value={reportType}
                options={this.reportTypeOptions}
                onChange={this.onChangeReportType}
                optionLabel="label"
                className="p-mt-2"
                style={{ width: '100%' }}
              />
            </div>
            <div className="p-text-right">
              {isSuppliersByCountry && (
                <Button
                  label={t('Total proveedores por país')}
                  className="p-button p-button-outlined p-button-prymary p-component p-button-rounded p-mt-3 p-mb-4 p-mr-3"
                  onClick={this.onTotalSupplierByCountry}
                  loading={loadingBtn1}
                  icon="pi pi-download"
                />
              )}
              {validatePermissionAction(catalogPermissionsId.ACCESO_DETALLE_REPORTES) && (
                <Button
                  label={isSuppliersByCountry ? t('Detalle de proveedores') : t('Detalle de terceros')}
                  className="p-button p-button-outlined p-button-secondary p-component p-button-rounded p-mt-3 p-mb-4"
                  onClick={onDetail}
                  loading={isConsolidated || isUnassociatedMS ? loadingBtn1 : loadingBtn2}
                  icon="pi pi-download"
                />
              )}
            </div>
            {this.renderReportTable()}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = () => ({});

const mapDispatchToProps = {
  getReportTotalSupplierByCountry,
  reportTotalSupplierByCountry,
  reportDetailSupplier,
  getReportTotalFoliosPC,
  getReportUnassociatedMSDetail,
  reportUnassociatedMSDetail,
  reportDetailPC,
  validatePermissionAction,
};

export default compose(
  withTranslation(),
  connect(mapStateToProps, mapDispatchToProps)
)(ReportUsersSuppliers);
